"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var mobileStylesHelper_1 = __importDefault(require("../assets/mobileStylesHelper"));

var mobile = {
  '& input': {
    height: 46
  },
  '& $input$withIcon': {
    paddingRight: 40
  },
  '& $passwordEye': {
    right: 16
  }
};

exports.styles = function (_a) {
  var fontFamily = _a.fontFamily,
      fontControl = _a.fontControl,
      colorTextSecondary = _a.colorTextSecondary,
      colorText = _a.colorText,
      sizeControlHeight = _a.sizeControlHeight,
      sizeBorderWidth = _a.sizeBorderWidth,
      paddingControlHorizontal = _a.paddingControlHorizontal;
  return __assign(__assign({
    input: __assign(__assign({
      fontFamily: fontFamily,
      background: 'transparent',
      border: 'none',
      padding: "0 " + paddingControlHorizontal + "px",
      height: sizeControlHeight - 2 * sizeBorderWidth,
      boxSizing: 'border-box',
      width: '100%',
      margin: 0,
      lineHeight: 23,
      color: colorText.normal
    }, fontControl), {
      '&:focus, &$focus': {
        outline: 'none'
      },
      '&::-ms-clear, &::-ms-reveal': {
        display: 'none'
      },
      '&::-webkit-input-placeholder': {
        color: colorTextSecondary.normal
      },
      '&:-moz-placeholder': {
        color: colorTextSecondary.normal
      },
      '&::-moz-placeholder': {
        color: colorTextSecondary.normal
      },
      '&:-ms-input-placeholder': {
        color: colorTextSecondary.normal
      },
      '&::-ms-input-placeholder': {
        color: colorTextSecondary.normal
      }
    }),
    withIcon: {
      paddingRight: 36
    }
  }, mobileStylesHelper_1.default(mobile)), {
    hover: {},
    focus: {},
    passwordEye: {
      cursor: 'pointer',
      position: 'absolute',
      height: '100%',
      top: 0,
      right: 12,
      verticalAlign: 'middle',
      '& > svg': {
        verticalAlign: 'middle'
      },
      '&::after': {
        content: '""',
        height: '100%',
        display: 'inline-block',
        width: 0,
        verticalAlign: 'middle',
        overflow: 'hidden'
      }
    }
  });
};